import React from 'react';
import ManualBookShell from './manual/ManualBookShell';

const circuitoMedico = [
  {
    title: '1. Llega a tu bandeja',
    body: 'Administración derivó el caso (o ingresaste uno por DNI). Aparece en Pedidos/Recetas como pendiente.'
  },
  {
    title: '2. Revisás y coordinás',
    body: 'Leés paciente, medicamento y comentarios de derivación. Si falta algo operativo, mensaje interno a administración.'
  },
  {
    title: '3. Aprobás o rechazás',
    body: 'Decisión clínica en el wizard de 3 pasos: datos del tratamiento, emisión/WhatsApp y médico tratante.'
  },
  {
    title: '4. WhatsApp de alta',
    body: 'Si activaste el switch en el paso 2, el paciente recibe el aviso de plan aprobado al confirmar (paso 3).'
  },
  {
    title: '5. Sigue administración',
    body: 'Registran cada emisión en Recetas a emitir. El WhatsApp de emisión (si lo activaste) sale al registrar, no al aprobar.'
  }
];

const accesosOperativos = [
  {
    pantalla: 'Pedidos/Recetas',
    descripcion: 'Revisar, aprobar o rechazar pedidos derivados a vos; alta por DNI e historial.'
  },
  {
    pantalla: 'Trazabilidad recetas',
    descripcion: 'Auditoría del ciclo del pedido (solo con permiso asignado).'
  },
  {
    pantalla: 'Este manual',
    descripcion: 'Guía operativa del rol médico.'
  }
];

const manualPages = [
  { id: 'portada', label: 'Portada', eyebrow: 'Manual', title: 'Guía del médico' },
  { id: 'alcance', label: 'Intro', eyebrow: 'Bienvenida', title: 'Para qué sirve esta guía' },
  { id: 'circuito', label: 'Recorrido', eyebrow: 'Tu lugar en el flujo', title: 'Cómo avanza un caso' },
  { id: 'panorama', label: 'Pantalla I', eyebrow: 'Pedidos/Recetas', title: 'Lista y prioridad' },
  { id: 'revisar', label: 'Pantalla II', eyebrow: 'Pedidos/Recetas', title: 'Revisar un pedido' },
  { id: 'aprobar', label: 'Pantalla III', eyebrow: 'Pedidos/Recetas', title: 'Aprobar en 3 pasos' },
  { id: 'rechazar', label: 'Pantalla IV', eyebrow: 'Pedidos/Recetas', title: 'Rechazar un pedido' },
  { id: 'herramientas', label: 'Pantalla V', eyebrow: 'Pedidos/Recetas', title: 'Historial, chat y DNI' },
  { id: 'accesos', label: 'Accesos', eyebrow: 'Tu usuario', title: 'Qué pantallas podés usar' },
  { id: 'faq', label: 'Consultas', eyebrow: 'Ayuda rápida', title: 'Preguntas frecuentes' }
];

function NoteList({ items, styles }) {
  return (
    <div style={styles.pageStackCompact}>
      {items.map((item) => (
        <div key={item} style={styles.noteRowSoft}>
          <span style={styles.noteAccentSoft} />
          <span style={{ color: '#1e293b', lineHeight: 1.65, fontSize: 14 }}>{item}</span>
        </div>
      ))}
    </div>
  );
}

function StepCards({ steps, styles, compactCardStyle }) {
  return (
    <div style={styles.pageStack}>
      {steps.map((step) => (
        <article key={step.title} style={compactCardStyle}>
          <h3 style={styles.cardTitle}>{step.title}</h3>
          <p style={{ ...styles.copy, marginBottom: 0 }}>{step.body}</p>
        </article>
      ))}
    </div>
  );
}

function AccesosTable({ styles, compact }) {
  return (
    <div style={{ display: 'grid', gap: compact ? 6 : 8 }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: compact ? '1fr' : 'minmax(160px, 0.4fr) 1fr',
        gap: 8,
        padding: '8px 12px',
        borderRadius: 12,
        background: 'linear-gradient(135deg, #163d6b 0%, #2365ab 100%)',
        color: '#f8fbff',
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: '0.06em',
        textTransform: 'uppercase'
      }}>
        {!compact && <span>Pantalla</span>}
        <span>Qué hacés ahí</span>
      </div>
      {accesosOperativos.map((row) => (
        <article
          key={row.pantalla}
          style={{
            ...styles.infoCard,
            padding: compact ? 10 : 12,
            display: 'grid',
            gridTemplateColumns: compact ? '1fr' : 'minmax(160px, 0.4fr) 1fr',
            gap: compact ? 4 : 10,
            alignItems: 'start'
          }}
        >
          <div style={{ fontSize: compact ? 12 : 13, fontWeight: 800, color: '#163d6b', lineHeight: 1.35 }}>
            {row.pantalla}
          </div>
          <div style={{ fontSize: compact ? 12 : 13, color: '#334155', lineHeight: 1.55 }}>
            {row.descripcion}
          </div>
        </article>
      ))}
    </div>
  );
}

function renderManualPage(pageId, styles, { isMobile, forExport, manualPages: pages }) {
  const compactCardStyle = {
    ...styles.infoCard,
    padding: forExport ? 14 : styles.infoCard.padding,
    boxShadow: forExport ? 'none' : styles.infoCard.boxShadow
  };

  switch (pageId) {
    case 'portada':
      if (forExport) {
        return (
          <div style={styles.exportCoverShell}>
            <div style={styles.exportCoverOverline}>Guía de trabajo</div>
            <div style={styles.exportCoverBrand}>Pulse · Médico</div>
            <h1 style={styles.exportCoverTitle}>Manual del médico</h1>
            <p style={styles.exportCoverText}>
              Pedidos/Recetas, wizard de aprobación y avisos WhatsApp — junio 2026.
            </p>
            <div style={styles.exportCoverDivider} />
            <div style={styles.exportCoverFooter}>
              <span style={styles.exportCoverFooterItem}>Revisión</span>
              <span style={styles.exportCoverFooterItem}>Aprobación</span>
              <span style={styles.exportCoverFooterItem}>WhatsApp</span>
            </div>
          </div>
        );
      }

      return (
        <div style={styles.coverPageShell}>
          <div style={styles.coverPageGlow} />
          <div style={styles.coverPageTopline}>Guía de trabajo</div>
          <div style={styles.coverPageBrand}>Pulse · Rol médico</div>
          <h1 style={styles.coverPageTitle}>Manual del médico</h1>
          <p style={styles.coverPageText}>
            Cómo revisar pedidos, aprobar en 3 pasos, configurar emisión y avisos WhatsApp al paciente.
          </p>
          <div style={styles.coverPageEditionRow}>
            <span style={styles.coverPageEditionChip}>Junio 2026</span>
            <span style={styles.coverPageEditionChip}>{pages.length} capítulos</span>
            <span style={styles.coverPageEditionChip}>Actualizado</span>
          </div>
          <div style={styles.coverPageDivider} />
          <div style={styles.coverPageMetaGrid}>
            <div style={styles.coverPageMetaCard}>
              <div style={styles.coverPageMetaLabel}>Pantalla</div>
              <div style={styles.coverPageMetaValue}>Pedidos/Recetas</div>
            </div>
            <div style={styles.coverPageMetaCard}>
              <div style={styles.coverPageMetaLabel}>Decisión</div>
              <div style={styles.coverPageMetaValue}>Aprobar o rechazar</div>
            </div>
            <div style={styles.coverPageMetaCard}>
              <div style={styles.coverPageMetaLabel}>Wizard</div>
              <div style={styles.coverPageMetaValue}>3 pasos</div>
            </div>
          </div>
        </div>
      );

    case 'alcance':
      return (
        <div style={styles.pageStack}>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>¿Para quién es?</h3>
            <p style={styles.copy}>
              Para médicos que revisan pedidos derivados desde administración.
              Tu pantalla principal es Pedidos/Recetas.
            </p>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Qué vas a aprender</h3>
            <NoteList
              styles={styles}
              items={[
                'Priorizar la cola por tiempo de espera.',
                'Aprobar con el wizard: posología, emisor, WhatsApp y médico tratante.',
                'Rechazar con motivo claro para el paciente.',
                'Coordinarte con administración sin mezclar canales.'
              ]}
            />
          </article>
          <div style={styles.highlightPanel}>
            <div style={styles.highlightTitle}>Tu responsabilidad</div>
            <p style={{ ...styles.highlightPanelText, marginBottom: 0 }}>
              Vos decidís clínicamente. Administración deriva y registra emisiones; no reemplaza tu criterio.
            </p>
          </div>
        </div>
      );

    case 'circuito':
      return <StepCards steps={circuitoMedico} styles={styles} compactCardStyle={compactCardStyle} />;

    case 'panorama':
      return (
        <div style={styles.pageStack}>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Entrada</h3>
            <p style={styles.copy}>
              Menú Recetas → <strong>Pedidos/Recetas</strong>. KPIs: pendientes, aprobados hoy, rechazados, en tratamiento.
              Buscador y Acciones (Historial global, Ingreso por DNI).
            </p>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Cola y colores</h3>
            <NoteList
              styles={styles}
              items={[
                'Verde: menos de 1 hora en cola.',
                'Amarillo: hasta 1 día.',
                'Naranja: 1 a 3 días.',
                'Rojo: más de 3 días — usá «Ver primero» en la alerta de cola.'
              ]}
            />
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Layout</h3>
            <p style={{ ...styles.copy, marginBottom: 0 }}>
              Tarjetas a la izquierda; al elegir una, el panel derecho muestra detalle e historial del paciente.
            </p>
          </article>
        </div>
      );

    case 'revisar':
      return (
        <div style={styles.pageStack}>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Abrir y leer</h3>
            <p style={styles.copy}>
              Expandí la tarjeta: medicamento (nombre, laboratorio, presentación), paciente, obra social,
              médico asignado y comentarios de derivación.
            </p>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Antes de decidir</h3>
            <ul style={styles.list}>
              <li>¿Paciente y DNI correctos?</li>
              <li>¿Medicamento adecuado al caso?</li>
              <li>¿Leíste notas de administración?</li>
              <li>Si el fármaco está mal cargado, corregilo antes de aprobar/rechazar.</li>
            </ul>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Acciones</h3>
            <p style={{ ...styles.copy, marginBottom: 0 }}>
              <strong>Aprobar tratamiento</strong>, <strong>Rechazar</strong> o mensaje interno a administración.
            </p>
          </article>
        </div>
      );

    case 'aprobar':
      return (
        <div style={styles.pageStack}>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Wizard en 3 pasos</h3>
            <ol style={styles.list}>
              <li><strong>Datos del tratamiento:</strong> posología, cantidad de recetas (1–12), fecha de inicio, período en meses.</li>
              <li><strong>WhatsApp y emisión:</strong> quién emite (médico o administrativo), switches de WhatsApp.</li>
              <li><strong>Médico tratante:</strong> confirmás asignación (o elegís médico en alta manual).</li>
            </ol>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Badge de recordatorios</h3>
            <p style={styles.copy}>
              Más de 1 receta → «Suscripto a recordatorios». Una sola receta → «Sin recordatorios».
              Los switches de WhatsApp se sugieren según cantidad; podés cambiarlos en el paso 2.
            </p>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Emisor y WhatsApp</h3>
            <ul style={styles.list}>
              <li><strong>Médico:</strong> seguís en Pedidos/Recetas.</li>
              <li><strong>Administrativo:</strong> el caso va a Recetas a emitir del administrativo elegido.</li>
              <li><strong>Alta tratamiento (Activo):</strong> WhatsApp al confirmar aprobación (paso 3).</li>
              <li><strong>Emitir receta (Activo):</strong> WhatsApp cuando administración registre la emisión, no al aprobar.</li>
            </ul>
          </article>
          <div style={styles.highlightPanelAlt}>
            <div style={styles.highlightTitle}>Confirmar</div>
            <p style={{ ...styles.highlightPanelText, marginBottom: 0 }}>
              En paso 3 pulsá <strong>Confirmar aprobación</strong>. Se cierra el wizard y aparece el diálogo final «Aprobar pedido».
            </p>
          </div>
        </div>
      );

    case 'rechazar':
      return (
        <div style={styles.pageStack}>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Cuándo rechazar</h3>
            <p style={styles.copy}>
              Cuando el tratamiento no corresponde o falta información clínica indispensable.
              Es una decisión médica responsable.
            </p>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Paso a paso</h3>
            <ol style={styles.list}>
              <li>Pulsá <strong>Rechazar</strong>.</li>
              <li>Escribí motivo claro y comprensible para el paciente.</li>
              <li>Confirmá.</li>
            </ol>
          </article>
          <div style={styles.highlightPanel}>
            <div style={styles.highlightTitle}>Importante</div>
            <p style={{ ...styles.highlightPanelText, marginBottom: 0 }}>
              El motivo puede usarse para notificar al paciente. Si solo falta un dato operativo, probá primero el mensaje interno a administración.
            </p>
          </div>
        </div>
      );

    case 'herramientas':
      return (
        <div style={styles.pageStack}>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Corregir medicamento</h3>
            <p style={styles.copy}>
              Edición en la tarjeta → buscador del catálogo → guardar. Solo para errores de carga, no para cambiar la decisión clínica.
            </p>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Historial</h3>
            <p style={styles.copy}>
              Panel derecho al seleccionar un pedido. <strong>Historial global</strong> (Acciones) para buscar en todos los pacientes por DNI, fechas y estado.
            </p>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Mensaje interno e ingreso por DNI</h3>
            <p style={styles.copy}>
              Mensaje interno: coordinación con administración; el paciente no lo ve.
              <strong> Ingreso por DNI</strong> (Acciones): alta rápida cuando el paciente está en padrón y no vino por derivación. Al aprobar, podés tener que confirmar médico tratante.
            </p>
          </article>
        </div>
      );

    case 'accesos':
      return (
        <div style={styles.pageStack}>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>Menú según permisos</h3>
            <p style={styles.copy}>
              Solo ves pantallas asignadas en Admin Permisos. Para operar como médico necesitás Pedidos/Recetas y este manual.
            </p>
          </article>
          <AccesosTable styles={styles} compact={isMobile} />
        </div>
      );

    case 'faq':
      return (
        <div style={styles.pageStack}>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>No veo pedidos</h3>
            <p style={styles.copy}>
              Puede no haber derivaciones a vos, o el buscador está filtrando. Limpiá el buscador y esperá actualización.
            </p>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>¿Cuándo sale el WhatsApp de emisión?</h3>
            <p style={styles.copy}>
              Solo cuando administración registra la emisión en Recetas a emitir, si dejaste el switch Activo en el paso 2.
            </p>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>¿Puedo cambiar algo después de aprobar?</h3>
            <p style={styles.copy}>
              La aprobación define el tratamiento. Errores operativos: coordiná con administración.
            </p>
          </article>
          <article style={compactCardStyle}>
            <h3 style={styles.cardTitle}>¿Dónde hablo con el paciente?</h3>
            <p style={{ ...styles.copy, marginBottom: 0 }}>
              No por el mensaje interno de Pedidos/Recetas. Usá los canales de atención habituales de la obra social.
            </p>
          </article>
        </div>
      );

    default:
      return null;
  }
}

export default function AdminManualMedico() {
  return (
    <ManualBookShell
      manualPages={manualPages}
      renderManualPage={renderManualPage}
      pdfFileName="manual-medico-pulse-a4.pdf"
      pdfPreviewTitle="Manual médico - PDF A4"
    />
  );
}
